<!--
 * @Autor: zhiying Qin
 * @Date: 2025-04-09 23:30:57
 * @LastEditTime: 2025-05-18 21:15:43
-->
<template>
  <div class="precisePost">
    <div class="title">
      <van-button type="info" block>精准匹配</van-button>
    </div>

    <listPost type="precisePost"></listPost>
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" replace to="/tool">首页</van-tabbar-item>
      <van-tabbar-item icon="orders-o" @click="toUrl('/enterpriseList')">企业名录</van-tabbar-item>
      <van-tabbar-item icon="apps-o" replace to="/intelligencePost">标准筛岗</van-tabbar-item>
      <van-tabbar-item icon="bookmark-o">智能筛岗</van-tabbar-item>
      <!-- <van-tabbar-item icon="setting-o" replace to="/home">重点标识</van-tabbar-item> -->
      <van-tabbar-item icon="manager-o" replace to="/myCollect">我的收藏</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Tabbar, TabbarItem } from 'vant';

Vue.use(Tabbar);
Vue.use(TabbarItem);
import tools from "@/libs/utils";
import { postList, getPostFilter } from "@/api/xicaiquan";
import { Button } from "vant";
Vue.use(Button);
import listPost from "./component/listPost.vue";
export default {
  name: "precisePost",
  data() {
    return {
      active:3,
      queryParams: {
        pageNum: 1,
        size: 10,
      },
    };
  },
  created() {
    if (!tools.getToken1()) {
      this.$router.replace({ path: "/login" });
    }

    // this.getPostFilter();
    // this.postList();
  },
  components: {
    listPost,
  },
  watch: {},
  methods: {
    // async getPostFilter() {
    //   const res = await getPostFilter();
    //   console.log(res);
    // },
    // async postList() {
    //   const res = await postList(this.queryParams);
    //   console.log(res);
    // },
    toUrl (path) {
      if (!path) {
        Toast('功能开发中')
        return
      }

      this.$router.replace({ path })
    }
  },
};
</script>
<style scoped lang="scss">
.title {
  padding: 20px 10px;
}
</style>
